import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import MainLayout from '../../../layouts/MainLayout';
import { Loader, Center } from '@/components/ui';

import ResourcesDashboard from './dashboard';

const CoursesPage = lazy(() => import('./courses'));
const CourseDetailPage = lazy(() => import('./courses/[id]'));
const CategoriesPage = lazy(() => import('./categories'));
const KnowledgeBasePage = lazy(() => import('./knowledge-base'));
const KnowledgeBaseDetailPage = lazy(() => import('./knowledge-base/[id]'));
const KBArticleDetailPage = lazy(() => import('./knowledge-base/articles'));
const ProgressPage = lazy(() => import('./progress'));
const AnalyticsPage = lazy(() => import('./analytics'));
const LookupAdminPage = lazy(() => import('./admin/lookups'));
const AdminSettingsPage = lazy(() => import('./admin/settings'));

const LoadingFallback = () => (
  <Center h={400}>
    <Loader size="lg" />
  </Center>
);

export default function ResourceManagementRoutes() {
  return (
    <MainLayout domainKey="resources">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<ResourcesDashboard />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:id" element={<CourseDetailPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="/knowledge-base/articles/:articleId" element={<KBArticleDetailPage />} />
          <Route path="/knowledge-base/:id" element={<KnowledgeBaseDetailPage />} />
          <Route path="/progress" element={<ProgressPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/admin/lookups/*" element={<LookupAdminPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="*" element={<Navigate to="/app/resources" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
